/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { processorModuleBaseOperationsActions } from "./gen/creators.js";

/** Actions for the ProcessorModule document model */

export const actions = {
  ...baseActions,
  ...processorModuleBaseOperationsActions,
};
